import React from 'react';
export const CONSTANTS = {
  ACTIONS: {
    FETCH_GET_CARD_LIST_SUCCESS: 'FETCH_GET_CARD_LIST_SUCCESS',
    FETCH_GET_CARD_LIST_ERROR: 'FETCH_GET_CARD_LIST_ERROR',
    FETCH_GET_FAVCARD_LIST_SUCCESS: 'FETCH_GET_FAVCARD_LIST_SUCCESS',
    FETCH_GET_FAVCARD_LIST_ERROR: 'FETCH_GET_FAVCARD_LIST_ERROR',
    SET_FILTER_CARDS: 'SET_FILTER_CARDS',
    ADD_FAVCARD_LIST_ERROR: 'ADD_FAVCARD_LIST_ERROR',
    FETCH_GET_USER_DETAILS_SUCCESS: 'FETCH_GET_USER_DETAILS_SUCCESS',
    FETCH_GET_USER_DETAILS_ERROR: 'FETCH_GET_USER_DETAILS_ERROR',
    FETCH_UPDATE_USER_DETAILS_SUCCESS: 'FETCH_UPDATE_USER_DETAILS_SUCCESS',
    FETCH_UPDATE_USER_DETAILS_ERROR: 'FETCH_UPDATE_USER_DETAILS_ERROR',
    RESET_USER_DETAIL_API_EVENT: 'RESET_USER_DETAIL_API_EVENT',
    SET_BRANDS: 'SET_BRANDS',
    SET_EMAIL: 'SET_EMAIL',
    FETCH_GET_USER_PARTNER_SITE: 'FETCH_GET_USER_PARTNER_SITE',
    SET_CHAT_S3_URL: 'SET_CHAT_S3_URL',
    FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
    HAS_MORE_NOTIFICATION: 'HAS_MORE_NOTIFICATION',
    NOTIFICATION_LOADING: 'NOTIFICATION_LOADING',
    NOTIFICATION_FILTER: 'NOTIFICATION_FILTER',
    SET_ENCRYPT_KEY: 'SET_ENCRYPT_KEY',
    SET_UNREAD_NOTIFICATIONS_COUNT: 'SET_UNREAD_NOTIFICATIONS_COUNT',
    SET_TODO: 'SET_TODO',
    SET_FETCH_TODO_LOADING: 'SET_FETCH_TODO_LOADING',
    SET_SUPPORT_BRANDS: 'SET_SUPPORT_BRANDS',
    SET_TICKET_FIELDS: 'SET_TICKET_FIELDS',
    SET_TICKET_CREATION_FIELDS: 'SET_TICKET_CREATION_FIELDS',
    SET_TICKET_FIELD_OPTION: 'SET_TICKET_FIELD_OPTION',
    SET_SUPPORT_FORMS: 'SET_SUPPORT_FORMS',
    SET_REQUESTERS: 'SET_REQUESTERS',
    SET_GROUPS_LOOKUP: 'SET_GROUPS_LOOKUP',
    SET_LOADING: 'SET_LOADING',
    SET_TICKET_LOADER: 'SET_TICKET_LOADER',
    SET_TICKET_DRAWER_API: 'SET_TICKET_DRAWER_API',
    SET_PUSHER_CRED: 'SET_PUSHER_CRED'
  },
  OTHER_MODULES: ['/accountmanagement', '/agent', '/app', '/calendar', '/cms', '/home', '/tm', '/iotdealers', '/roles', '/report', '/reporting', '/rfid', '/ruleEngine', '/scheduling', '/support', '/masscomm', '/pm', '/external', '/crm', '/productmaster', '/template-builder']
};
export const URL_MODULE_MAP = {
  '/home': 'taskmanagement',
  '/tm': 'taskmanagement',
  '/accountmanagement': 'accountmanagement',
  '/scheduling': 'scheduling',
  '/calendar': 'calendar',
  '/support': 'support',
  '/agent': 'agent',
  '/monitor': 'monitor',
  '/cms': 'cms',
  '/roles': 'roles',
  '/app': 'app',
  '/report': 'hardwarereport',
  '/reporting': 'reporting',
  '/ruleEngine': 'ruleEngine',
  '/iotdealers': 'iotdealers',
  '/rfid': 'rfid',
  '/masscomm': 'masscommunications',
  '/pm': 'programtracker',
  '/external': 'thirdparty',
  '/crm': 'crm',
  '/productmaster': 'productmaster',
  '/rm': 'resource-management',
  '/implementation': 'implementation',
  '/user-management': 'user-management',
  '/dashboard': 'dashboard',
  '/om': 'object-management',
  '/invoicing': 'invoicing',
  '/template-builder': 'template-builder'
};
export const PROD_BASE_URLS = ['https://us-west1-tapapi.tekioncloud.com', 'https://gm-tapapi.tekioncloud.com', 'https://renault-tapapi.tekioncloud.com', 'https://aurora-tapapi.tekioncloud.com', 'https://campingworld-tap.tekioncloud.com'];

/**
 * @description Function performs no operation
 */
export const NO_OP = () => {};
export const EMPTY_ARRAY = Object.freeze([]);
export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ROW = Object.freeze([EMPTY_OBJECT]);
export const EMPTY_STRING = '';
export const EMPTY_FRAGMENT = /*#__PURE__*/React.createElement(React.Fragment, null);
export const EMPTY_MAP = Object.freeze(new Map());
export const ACCEPTED_FILE_TYPES = ["application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword", "application/pdf", "application/vnd.google-earth.kml+xml", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.presentation", "application/vnd.oasis.opendocument.spreadsheet", "application/vnd.sun.xml.calc", "audio/aiff", "audio/basic", "audio/flac", "audio/midi", "application/vnd.rn-realmedia-vbr", "audio/x-m4a", "audio/mpeg", "audio/ogg", "audio/wav", 'audio/aac', "image/gif", "image/jpeg", "image/png", "image/tiff", "image/bmp", "text/calendar", "text/csv", "text/plain; charset=utf-8", "text/html; charset=utf-8", "text/vcard", "video/mp4", "video/mpeg", "video/ogg", "video/quicktime", "video/x-msvideo"].join(', ');
export const TAP_SUPPORT_BRAND_ID = 'ckknsr0nw0000tyd2nd9njcfs';
export const DEFAULT_ACTIVE_MENU_TAB = 'apps';
export const dateFormat = 'MM/DD/YYYY';
export const LANGUAGE_OPTIONS = [{
  label: 'USA - English',
  value: 'en_US'
}, {
  label: 'France - French',
  value: 'fr_FR'
}, {
  label: 'Canada - French',
  value: 'fr_CA'
}];
export const OKTA_ERRORS = {
  JWT_ISSUED_IN_FUTURE: 'The JWT was issued in the future',
  USER_NOT_ASSIGNED_TO_APP: 'User is not assigned to the client application.',
  JWT_EXPIRED: 'The JWT expired and is no longer valid'
};
export const FILTER_CONFIG = {
  visible: 'show_filters',
  expanded: 'expand_filters'
};
export const FILTER_TYPES = [{
  id: 'user',
  name: __('User'),
  type: 'SINGLE_SELECT',
  additional: {
    options: []
  }
}, {
  id: 'date',
  name: 'Date',
  type: 'DATE'
}];
export const DATE_OVERIDES_TYPE = {
  AVAILABLE: 'available',
  HOLIDAY: 'holiday',
  UNAVAILABLE: 'unavailable'
};
export const DEFAULT_TIME_FORMAT = 'HH:mm';
export const FORMATTED_TIME_FORMAT = 'hh:mm A';
export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const FORMATTED_DATE_FORMAT = 'MM/DD/YYYY';
export const DATE_OVERIDES_MAP = {
  [DATE_OVERIDES_TYPE.HOLIDAY]: {
    color: '#4285f4',
    label: __('Holiday')
  },
  [DATE_OVERIDES_TYPE.UNAVAILABLE]: {
    color: '#ff8181',
    label: __('PTO/Unavailable')
  },
  [DATE_OVERIDES_TYPE.AVAILABLE]: {
    color: '#00bfa5',
    label: __('Available on Exception')
  }
};